import { SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';
import { discoverProjectEnvironmentTypesListenerSaga } from './discover-project-environment-types';
import { listProjectEnvironmentTypesListenerSaga } from './list-project-environment-types';

export function* rootSaga(): SagaIterator {
    yield all([fork(discoverProjectEnvironmentTypesListenerSaga), fork(listProjectEnvironmentTypesListenerSaga)]);
}
